export default class DesignConsistency {
  static init() {
    DesignConsistency.addSpacerClassToNecessaryRows();
    DesignConsistency.checkHeroChildrenContainerForComplexContent();
    DesignConsistency.addClassToParentOfHero();
  }

  static addSpacerClassToNecessaryRows() {
    const preSelector = '.vc_row:not(.vc_row-no-padding) .vc_column-inner > .wpb_wrapper > ';
    const selector = `${preSelector} .no-spacer, ${preSelector} .gform_wrapper`;

    $(selector).each((idx, element) => {
      const ancestors = $(element).parentsUntil('.vc_row:not(.vc_inner)');

      if (ancestors && ancestors.length > 0 && !ancestors.is('.adds-own-spacer')) {
        const oldestAncestorThatCouldBeChildOfRow = ancestors[ancestors.length - 1];

        if (oldestAncestorThatCouldBeChildOfRow) {
          const parent = $(oldestAncestorThatCouldBeChildOfRow).parent();

          if (parent && parent.hasClass('vc_row')) {
            parent.addClass('add-spacer');
          }
        }
      }
    });
  }

  static checkHeroChildrenContainerForComplexContent() {
    const is2023BlogSingle = document.querySelector('body.single-post.blog-design-2023') !== null;

    if (is2023BlogSingle) {
      return;
    }
    
    const container = $('.hero-children-container');
    const noOfRows = container.find('.vc_row.vc_inner').length;
    const noOfColumns = container.find('.vc_row.vc_inner .wpb_column').length;

    if (noOfRows >= 1 && noOfColumns > 1) {
      container.removeClass('adds-own-spacer').addClass('complex-content');
    }
  }

  static addClassToParentOfHero() {
    const heros = document.querySelectorAll('.hero');

    if (!heros || !heros.length) {
      const body = document.querySelector('body');
      body.classList.add('page-has-no-hero');
      return;
    }

    heros.forEach((hero) => {
      if (hero.classList.contains('hero-with-video')) {
        return;
      }

      const parentRow = hero.closest('.vc_row:not(.vc_inner)');

      if (parentRow) {
        let nextRow = parentRow.nextElementSibling;

        if (nextRow && !nextRow.matches('.vc_row')) {
          nextRow = nextRow.nextElementSibling;
        }

        if (nextRow && nextRow.matches('.vc_row.white-bg')) {
          hero.style.setProperty('--curve-fill-color', '#fff');
        }
      }
      
      const curveFillColor = hero.style.getPropertyValue('--curve-fill-color');

      hero.parentElement.classList.add('has-hero');
      hero.parentElement.style.setProperty('--curve-fill-color', curveFillColor);
    });
  }
}
